// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "channels";
global.toastr = require("toastr")

require("jquery");
require("bootstrap");
require("packs/bootstrap-datetimepicker.min")
require("@fortawesome/fontawesome-free/css/all.css");
require("packs/sidebar.js");
require("packs/custom.js");
require('packs/otp');
require("trix")
require("@rails/actiontext")

require("packs/app.min.js");
require("@nathanvda/cocoon");
import "packs/jquery.multi-select.js";
import "select2";
import "select2/dist/css/select2.css";

require('toastr');

const images = require.context("../images", true);
import Sortable from "sortablejs";
import "chartkick/chart.js"
require("chart.js")
require("timepicker");
import "timepicker/jquery.timepicker.css";
require('parsleyjs');
require('fabric');
require('jquery.blockUI.min.js')
import 'bootstrap-datepicker';
import "../stylesheets/application";
require("jquery-ui/ui/widgets/draggable")
require("packs/crm_cart.js");
require("packs/owl.carousel.min.js")
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import moment from 'moment';

window.$ = $;
window.FullCalendar = { Calendar, dayGridPlugin, interactionPlugin };
window.moment = moment;

window.Sortable = Sortable;   // To make the Sortable library accessible as a global variable
document.addEventListener("turbolinks:load", () => {
  $('[data-toggle="tooltip"]').tooltip();
  $('[data-toggle="popover"]').popover();

  const sortingElement = document.getElementById("sortable-elem");

  // get calls only if div with id sortable-elem and onEnd function exists
  if (sortingElement && (typeof updateSortableOnEnd === "function")) {
    Sortable.create(sortingElement, {
      handle: ".sorting-handler",
      onEnd: updateSortableOnEnd,
    });
  }

  initDashboardCardSorting();
});

// Drag the dashboard statistic cards into any order and save it for this user. Global because the
// date filter re-renders the partial over AJAX and index.js.erb has to re-bind. -AI1
window.initDashboardCardSorting = function () {
  const dashboardCards = document.getElementById("dashboard-cards");
  if (!dashboardCards || dashboardCards.dataset.sortableBound === "true") return;

  // Cards render in their default order, so apply the saved one here. Unknown keys are skipped and
  // cards the user has not seen go last, so every card shows exactly once.
  let savedOrder = [];
  try {
    savedOrder = JSON.parse(dashboardCards.dataset.cardOrder || "[]");
  } catch (e) {
    savedOrder = [];
  }
  if (savedOrder.length) {
    const cards = Array.from(dashboardCards.querySelectorAll(".dashboard-card"));
    const byKey = new Map(cards.map((el) => [el.dataset.cardKey, el]));
    const ordered = savedOrder.map((key) => byKey.get(key)).filter(Boolean);
    cards.forEach((el) => {
      if (!ordered.includes(el)) ordered.push(el);
    });
    ordered.forEach((el) => dashboardCards.appendChild(el));
  }

  dashboardCards.dataset.sortableBound = "true";
  Sortable.create(dashboardCards, {
    draggable: ".dashboard-card",
    handle: ".dashboard-card-handle",
    animation: 150,
    ghostClass: "dashboard-card-ghost",
    onEnd: () => {
      const keys = Array.from(
        dashboardCards.querySelectorAll(".dashboard-card")
      ).map((el) => el.dataset.cardKey);

      $.ajax({
        url: dashboardCards.dataset.saveUrl,
        type: "POST",
        data: { card_keys: keys },
        headers: { "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content") },
      });
    },
  });
};

$(document).on('change', '.selectAllModule', function(){
  var is_checked = $(this).is(':checked')
  var check_class = '.'+ $(this).data('id')
  $(check_class).prop('checked', is_checked)
})

$(document).on('turbolinks:before-cache', function () {
  $('#invoice_customer_id').each(function () {
    if ($(this).data('select2')) {
      $(this).select2('destroy');
    }
  });
});

Rails.start();
Turbolinks.start();
ActiveStorage.start();

require("trix")
require("@rails/actiontext")